import React from 'react';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';

const SidebarTitleComponent = ({ user }) => {
  const title = t('account-settings.edit-user-access.edit-user-title', {
    userName: user?.full_name || user?.email,
  });

  return (
    <div className="content-title-box without-background">
      <div className="flex-auto">
        <h3 className="content-heading">{user.id ? title : t('users.create-user.title')}</h3>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { user } = getUserPermissionsState(state);
  return { user };
};

export const SidebarTitle = connectWithStore(mapStateToProps)(SidebarTitleComponent);
